import { render, staticRenderFns } from "./teamIntroduction.vue?vue&type=template&id=5bf2bb64&scoped=true&"
import script from "./teamIntroduction.vue?vue&type=script&lang=js&"
export * from "./teamIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./teamIntroduction.vue?vue&type=style&index=0&id=5bf2bb64&lang=less&scoped=true&"
import style1 from "./teamIntroduction.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf2bb64",
  null
  
)

export default component.exports